module.exports = __webpack_public_path__ + "img/about.3946684e.jpg";